<style>
.care>.tip>.text>.title{
  font-size: 16px;
  margin-bottom: 0;
}
.care>.tip>.text>.remark{
  font-size: 14px;
  margin-top: 13px;
  color: #666;
}
.care>.tip>.text{
  margin-left: 10px;
  float: left;
}
.care>.tip>.iconfont{
  color:#0099EE;
  margin-top: -2px;
}
.care>.tip>.iconfont{
  float: left;
  font-size: 70px;
}
.care>.tip>.iconfont.icon-qiye , .care>.tip>.iconfont.icon-wangzhan{
  margin-top: 6px;
  font-size: 64px;
}
</style>

<template>
  <el-row class="care container">
    <el-col :span="6" class="tip">
      <i class="iconfont icon-tuikuan"></i>
      <div class="text">
        <p class="title">无效退款</p>
        <p class="remark">优化无效全额退款</p>
      </div>
    </el-col>
    <el-col :span="6" class="tip">
      <i class="iconfont icon-sheji"></i>
      <div class="text">
        <p class="title">赠送网站</p>
        <p class="remark">海量模板任意挑选</p>
      </div>
    </el-col>
    <el-col :span="6" class="tip">
      <i class="iconfont icon-qiye"></i>
      <div class="text">
        <p class="title">老牌企业</p>
        <p class="remark">10年经验实力有保障</p>
      </div>
    </el-col>
    <el-col :span="6" class="tip">
      <i class="iconfont icon-wangzhan"></i>
      <div class="text">
        <p class="title">专业服务器</p>
        <p class="remark">独立服务器稳定高效</p>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'care'
}
</script>



// WEBPACK FOOTER //
// care.vue?eb39359c